export default __webpack_public_path__ + "e36e60992e7064d90f92da9c4370f337.bundle.svg";